import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// Time functions
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Utils
import MyButton from "../../util/MyButton";

// Post attributes
import DeletePost from "./DeletePost";
import PostDialog from "./PostDialog";
import LikeButton from "./LikeButton";
import SaveButton from "./SaveButton";

// MUI Imports
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
//import ShareIcon from "@material-ui/icons/Share";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Rating from "@material-ui/lab/Rating";

// widgets
import Emoji from "../widgets/Emoji";

// Redux
import { connect } from "react-redux";

const styles = (theme) => ({
  ...theme.spreadThis,
  card: {
    position: "relative",
    marginBottom: 20,
    borderRadius: 25,
  },
  media: {
    height: 325,
    paddingTop: "56.25%", // 16:9
    marginRight: 20,
    borderRadius: 5,
  },
  content: {
    padding: 25,
    objectFit: "cover",
  },
});

class Post extends Component {
  render() {
    dayjs.extend(relativeTime);
    const {
      classes,
      post: {
      //currentPost:{
        item,
        review,
        size,
        rating,
        usualSize,
        itemUrl,
        createdAt,
        userImage,
        userHandle,
        postId,
        //likeCount,
        commentCount,
        itemImage,
        userHeight,
        userWeight,
        userAge,
        price,
      },
      user: {
        authenticated,
        //credentials: { handle },
        userProfile: { handle },
      },
    } = this.props;

    var likeIndex = this.props.data.likes.findIndex((like) => like.postId === postId);
    let likeCount = 0;
    if(likeIndex !== -1) {
      likeCount = this.props.data.likes[likeIndex].handlesLiked.length;
    }


    const heightFt = Math.floor(userHeight / 12);
    const heightIn = userHeight % 12;
    const heightConverted = `${heightFt}' ${heightIn}"`;
    const deleteButton =
      authenticated && userHandle === handle ? (
        <DeletePost postId={postId} />
      ) : null;
    return (
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <Avatar
              alt={userHandle}
              src={userImage}
              component={Link}
              to={`/users/${userHandle}`}
            />
          }
          action={
            <IconButton aria-label="settings">
              <MoreVertIcon />
            </IconButton>
          }
          title={
            <div>
              <b>{userHandle} </b>
            </div>
          }
          subheader={dayjs(createdAt).fromNow()}
        />
        <Grid container spacing={1}>
          <Grid item sm={5}>
            <CardContent>
              <Rating name="read-only" value={rating} size="small" readOnly />
              <Typography variant="body2" color="textSecondary" component="p">
                <b>Item:</b> {item}
              </Typography>
              {itemUrl && (
                <Typography variant="body2" color="textSecondary" component="p">
                  <b>URL:</b>{" "}
                  <a href={itemUrl} target="_blank" rel="noopener noreferrer">
                    {new URL(itemUrl).origin}
                  </a>
                </Typography>
              )}
              {/* <Typography variant="body2" color="textSecondary" component="p">
                <b>Brand:</b>
              </Typography> */}
              <Typography variant="body2" color="textSecondary" component="p">
                <b>Price:</b> {price ? price : "not available"}
              </Typography>
              {size && (
                <Typography variant="body2" color="textSecondary" component="p">
                  <b>Size Worn:</b> {size.toUpperCase()}
                </Typography>
              )}
              <Typography variant="body2" color="textSecondary" component="p">
                <b>Review:</b> {review}
              </Typography>

              <hr></hr>

              <Typography variant="body2" color="textSecondary" component="p">
                <b>Usual Size:</b> {usualSize.toUpperCase()}
              </Typography>
              {userHeight && (
                <Typography variant="body2" color="textSecondary" component="p">
                  <b>Height:</b> {heightConverted}
                </Typography>
              )}
              {userWeight && (
                <Typography variant="body2" color="textSecondary" component="p">
                  <b>Weight:</b> {userWeight + " lbs"}
                </Typography>
              )}
              <Typography variant="body2" color="textSecondary" component="p">
                <b>Age:</b> {userAge}
              </Typography>

              <hr></hr>
              {/*<Typography variant="body2" color="textSecondary" component="p">
                  <Emoji symbol="💬" label="comments" /> <b> from :brand: </b>
                  {review}
                </Typography> */}
            </CardContent>
          </Grid>
          <Grid item sm={7}>
            <CardMedia
              image={itemImage}
              title={item}
              className={classes.media}
            />
          </Grid>
        </Grid>

        <CardActions disableSpacing>
          <LikeButton postId={postId} />
          <span>{likeCount}</span>
          <MyButton tip="comments">
            <Emoji symbol="💬" label="comments" />
          </MyButton>
          <span>{commentCount} comments</span>
          {/*<IconButton aria-label="share">
            <ShareIcon />
          </IconButton> */}
          <SaveButton postId={postId} />
          <PostDialog
            postId={postId}
            userHandle={userHandle}
            openDialog={this.props.openDialog}
          />
        </CardActions>
      </Card>
    );
  }
}

Post.propTypes = {
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  //currentPost: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
});

export default connect(mapStateToProps)(withStyles(styles)(Post));
